import { TradeByClientsReportFilter } from "../types";
import { User } from "../../../../auth/types";
import { httpWebApi } from "../../../../../core/http/httpThunks";
import { getParamsDateString } from "../../../../../core/util/functions";

export const getTradeByClientsExcel = (
  user: User,
  filter: TradeByClientsReportFilter
) => {
  return httpWebApi<Blob>({
    method: "GET",
    responseType: "blob",
    timeout: 60 * 4 * 1000,
    url: "reporting/getturnoverbyclixls",
    params: {
      userid: user.userId,
      datefrom: filter.datefrom,
      dateto: filter.dateto,
      clientId: filter?.clientId,
      cliStatus: filter?.cliStatus,
    },
  });
};

export default getTradeByClientsExcel;
